// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__video_card {
  position: relative;
  width: 210px;
  margin-left: 0 !important;
  margin-bottom: 10px;
  cursor: pointer;
}
@media (max-width: 576px) {
  .__video_card {
    width: 96px;
  }
}
.__video_card .__video_card_image {
  width: 210px;
  height: 210px;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;
  border: none;
}
@media (max-width: 576px) {
  .__video_card .__video_card_image {
    width: 96px;
    height: 96px;
  }
}
.__video_card ._play_video {
  width: inherit;
  height: inherit;
  position: absolute;
  z-index: 1;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  cursor: pointer;
}
.__video_card ._play_video img {
  width: 32px;
  height: 32px;
  display: none;
}
.__video_card:hover ._play_video {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/VideoCard/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AA4BJ;ADEE;ECnCF;IAQQ,WAAA;EA6BN;AACF;AA3BI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AA6BR;ADXE;ECxBE;IASQ,WAAA;IACA,YAAA;EA8BV;AACF;AA3BI;EACI,cAAA;EACA,eAAA;EAEA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;AA6BR;AA3BQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;AA6BZ;AAxBQ;EACI,cAAA;AA0BZ","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n\n.__video_card {\n    position: relative;\n    width: 210px;\n    margin-left: 0 !important;\n    margin-bottom: 10px;\n    cursor: pointer;\n\n    @include sm {\n        width: 96px;\n    }\n\n    .__video_card_image {\n        width: 210px;\n        height: 210px;\n        border-radius: 6px;\n        object-fit: cover;\n        cursor: pointer;\n        border: none;\n\n        @include sm {\n            width: 96px;\n            height: 96px;\n        }\n    }\n\n    ._play_video {\n        width: inherit;\n        height: inherit;\n        position: absolute;\n        position: absolute;\n        z-index: 1;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        margin: auto;\n        cursor: pointer;\n\n        img {\n            width: 32px;\n            height: 32px;\n            display: none;\n        }\n    }\n\n    &:hover {\n        ._play_video {\n            display: block\n        }\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
